import { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import { InputLabel } from "components/styledComponent/inputLabel";
import MyNumberFormat from "components/derived/numberFormat/numberFormat";
import { useTranslation } from "react-i18next";
import { usePropertiesConfigContext } from "components/context/propertiesConfig/customProperties";
import { getCurrencySymbol } from "components/custom/getCurrencySymbol";

export const AmountRange = ({
  filterValue,
  id,
  columnName,
  gridProps,
  dispatch,
}) => {
  const { t } = useTranslation();
  const { dynamicAmountSymbol } = usePropertiesConfigContext();
  const [minValue, setMinValue] = useState(
    Array.isArray(filterValue?.value) ? filterValue?.value[0] : null,
  );
  const [maxValue, setMaxValue] = useState(
    Array.isArray(filterValue?.value) ? filterValue?.value[1] : null,
  );
  const [error, setError] = useState("");
  useEffect(() => {
    if (Number(minValue) > Number(maxValue) && maxValue?.length > 0) {
      setError("From Amount should be less To Amount");
    } else {
      setError("");
    }
  }, [minValue, maxValue]);

  const handleBlur = (e) => {
    if (e.currentTarget.contains(e.relatedTarget)) {
      return;
    }
    if (
      !isNaN(Number(minValue)) &&
      !isNaN(Number(maxValue)) &&
      minValue?.length &&
      maxValue?.length &&
      Number(minValue) <= Number(maxValue)
    ) {
      dispatch({
        type: "setValue",
        payload: {
          condition: "between",
          value: [minValue, maxValue],
          id,
          columnName,
        },
      });
    } else {
      dispatch({
        type: "removeValue",
        payload: {
          id,
        },
      });
    }
  };
  return (
    <Grid item xs={12} sm={6} md={6} {...gridProps}>
      <FormControl
        fullWidth={true}
        error={Boolean(error)}
        tabIndex={1}
        onBlur={handleBlur}
        sx={{
          "& label.Mui-focused": {
            color: "var(--theme-color1)",
          },
        }}
      >
        <InputLabel shrink={true} sx={{ fontSize: "0.875rem !important" }}>
          {t(columnName)}
        </InputLabel>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <MyNumberFormat
            FormatProps={{
              thousandSeparator: true,
              prefix: "",
              thousandsGroupStyle: "lakh",
              allowNegative: false,
              allowLeadingZeros: false,
              decimalScale: 2,
              fixedDecimalScale: true,
              placeholder: "From amount",
              isAllowed: (values) => {
                if (values?.value?.length > 15) {
                  return false;
                }
                return true;
              },
              value: minValue,
              onValueChange: (value) => {
                if (!isNaN(Number(value.value))) {
                  setMinValue(String(value.value));
                }
              },
            }}
            enableGrid={false}
            fieldKey="FromAmount"
            name="from-amount"
            StartAdornment={getCurrencySymbol(dynamicAmountSymbol)}
            className="textInputFromRight"
            maxLength={15}
            showMaxLength={false}
            style={{ width: "48%" }}
          />

          <MyNumberFormat
            FormatProps={{
              thousandSeparator: true,
              prefix: "",
              thousandsGroupStyle: "lakh",
              allowNegative: false,
              allowLeadingZeros: false,
              decimalScale: 2,
              fixedDecimalScale: true,
              placeholder: "To amount",
              isAllowed: (values) => {
                if (values?.value?.length > 15) {
                  return false;
                }
                return true;
              },
              value: maxValue,
              onValueChange: (value) => {
                if (!isNaN(Number(value.value))) {
                  setMaxValue(String(value.value));
                }
              },
            }}
            enableGrid={false}
            fieldKey="ToAmount"
            name="to-amount"
            StartAdornment={getCurrencySymbol(dynamicAmountSymbol)}
            className="textInputFromRight"
            maxLength={15}
            showMaxLength={false}
            style={{ width: "48%" }}
          />
        </div>
        {Boolean(error) ? <FormHelperText>{error}</FormHelperText> : null}
      </FormControl>
    </Grid>
  );
};
